import React from 'react';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { contextNameKey } from '../../utils/theFreaks';
import useFreaksT from './useFreaksT';
import { contextIcon } from './contextIcon';

export default function FreaksContextPicker({ open, current, contexts, onClose, onPick }) {
  const { t } = useFreaksT();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { backgroundColor: '#0d1b2a', color: 'white', borderRadius: 4, m: 2, width: 'calc(100% - 32px)' } }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 20, px: 2, pt: 2 }}>{t('theFreaks.pickContext')}</Typography>
      <Typography sx={{ color: 'rgba(255,255,255,0.7)', px: 2, my: 1 }}>{t('theFreaks.pickContextHint')}</Typography>
      <List sx={{ overflowY: 'auto' }}>
        {contexts.map((context) => (
          <ListItemButton key={context} data-testid={`freaks-context-${context}`} onClick={() => onPick(context)} sx={{ minHeight: 48 }}>
            <ListItemIcon sx={{ color: 'rgba(255,255,255,0.8)', minWidth: 40 }}>{contextIcon(context, { fontSize: 22 })}</ListItemIcon>
            <ListItemText primary={t(contextNameKey(context))}/>
            {context === current ? <CheckIcon sx={{ color: DEFAULT_THEME_COLOR }}/> : null}
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
